import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import AuthHeader from '../AuthHeader';
import AuthField from '../AuthField';
import GoogleIcon from '../GoogleIcon';
import AuthProgress from '../AuthProgress';

// Step 1 of Register V2: identity only (name + email) plus the Google
// shortcut. Purely presentational — Register.js owns all state/handlers.
export default function AccountStep({
  headingRef, name, email, errors, loading,
  onNameChange, onEmailChange, onGoogleRegister, onContinue,
}) {
  return (
    <form onSubmit={onContinue} noValidate>
      <AuthProgress step={1} totalSteps={2} />
      <AuthHeader
        headingRef={headingRef}
        title="Bienvenue sur NSARA."
        subtitle="Créez votre espace et commencez à gérer votre activité."
      />

      <div className="auth-stack" style={{ marginBottom: 18 }}>
        <button type="button" className="auth-button auth-button-secondary" disabled={loading} onClick={onGoogleRegister}>
          <GoogleIcon /> Continuer avec Google
        </button>
      </div>
      <div className="auth-divider">ou</div>

      <AuthField
        id="register-name"
        label="Nom complet"
        type="text"
        autoComplete="name"
        value={name}
        onChange={onNameChange}
        placeholder="Votre nom complet"
        error={errors.name}
        required
      />
      <AuthField
        id="register-email"
        label="Adresse e-mail"
        type="email"
        autoComplete="email"
        inputMode="email"
        value={email}
        onChange={onEmailChange}
        placeholder="votre@email.com"
        error={errors.email}
        required
      />

      <div className="auth-stack">
        <button type="submit" className="auth-button auth-button-primary" disabled={loading}>
          Continuer
        </button>
      </div>

      <p className="auth-footer-line" style={{ marginTop: 18 }}>
        Déjà un compte ?{' '}
        <Link to="/login">Se connecter</Link>
      </p>
      <Link to="/" className="auth-home-link">
        <ArrowLeft size={14} aria-hidden="true" /> Retour à l'accueil
      </Link>
    </form>
  );
}
